<ul class="d-flex gap-2 flex-wrap" [formGroup]="filterForm">
  @for (filter of filterOptions() | slice: 0 : (showAllFilters() ? filterOptions().length : showByDefault); track $index) {
    @switch (filter.key) {
      @case ('date') {
        <li class="d-flex">
          <button class="button button--select" [matMenuTriggerFor]="menu" [class.has--value]="dateValueCount()">
            <!--<span>{{ filter.key }}</span>-->
            <span>{{ 'agenda-filter-' + filter.dict | fromDictionary }}</span>

            @if (dateValueCount(); as count) {
              <span class="chip chip--light chip--xs me-1">{{ count }}</span>
            }

            <fstr-icon matSuffix anchor="line-icon-chevron-down"></fstr-icon>
          </button>
          <mat-menu #menu="matMenu" class="p-0">
            <!-- prevent menu from closing when clicking on a option -->
            <div (click)="$event.stopPropagation()" class="calendar-menu">
              <!--<ul class="calendar-menu__quick-options p-3 p-sm-4">
                @for (option of filter.options; track option.id) {
                  <li>
                    <mat-radio [checked]="getChecked(filter.key, option.id)" (change)="handleDefaultDateOption(filter.key, option)">
                      {{ option.name }}
                    </mat-radio>
                  </li>
                }
              </ul>-->

              <mat-radio-group
                class="calendar-menu__quick-options p-3 p-sm-4"
                [formControlName]="filter.key"
                (change)="handleDefaultDateOption(filter.key)"
              >
                @for (option of filter.options; track option.id) {
                  <mat-radio-button class="calendar-menu__quick-options__item" [value]="option.id.toString()">
                    {{ option.name }}
                  </mat-radio-button>
                }
              </mat-radio-group>

              <div class="calendar-menu__calendar-container p-3 p-sm-4">
                <strong class="ms-1">{{ 'agenda-filter-selecteer-datum-titel' | fromDictionary }}</strong>
                <mat-calendar
                  class="calendar-menu__calendar"
                  #calendar
                  (selectedChange)="handleCalendar(filter.key, $event)"
                  [minDate]="minDate"
                ></mat-calendar>
              </div>
            </div>
          </mat-menu>
        </li>
      }

      @default {
        <li class="d-flex">
          <mat-form-field
            [floatLabel]="'always'"
            class="form-field--button-select"
            [class.has--value]="filterForm.get(filter.key)?.value?.length"
            [subscriptSizing]="'dynamic'"
          >
            <mat-label>
              <span>
                {{
                  ('agenda-filter-' + filter.dict | fromDictionary: false) ||
                    ('agenda-detail-meta-' + filter.dict | fromDictionary: false) ||
                    filter.key
                }}
              </span>

              @if (filterForm.get(filter.key)?.value?.length; as count) {
                <span class="chip chip--light chip--xs">{{ count }}</span>
              }
            </mat-label>
            <mat-select [formControlName]="filter.key" (valueChange)="filterChange(filter.key, $event)" multiple [panelWidth]="320">
              @for (option of filter.options; track option.id) {
                <mat-option [value]="option.id.toString()">
                  <div class="lh-base">
                    <span class="w-100 d-inline-block">{{ option.name }}</span>
                    @if (option.hint) {
                      <span class="fs-body-xxs text-muted d-inline-block mt-1">{{ option.hint }}</span>
                    }
                  </div>
                </mat-option>
              }
            </mat-select>

            <fstr-icon matSuffix anchor="line-icon-chevron-down" class="me-3"></fstr-icon>
          </mat-form-field>
        </li>
      }
    }
  }

  <li class="d-flex">
    <button class="button button--select-more" (click)="showAllFilters.set(!showAllFilters())">
      <span>{{ showAllFilters() ? 'Verberg opties' : 'Meer opties' }}</span>
      <fstr-icon [anchor]="showAllFilters() ? 'line-icon-minus' : 'line-icon-plus'"></fstr-icon>
    </button>
  </li>
</ul>

@if (hasFiltersActive$()) {
  <div class="py-4">
    <small class="fs-body-md fw-normal text-accent mb-1">Actieve filters</small>
    <ul class="d-flex column-gap-3 flex-wrap">
      @for (key of displayFilterValueKeys(); track key) {
        @for (val of filterValues()[key]; track val) {
          <!--@if (key !== 'to' && !(filterValues()['date'] && key === 'from')) {-->
          <li>
            <button
              class="button button-link button--light active-filter-option gap-1"
              (click)="removeFilter(key, val)"
              [attr.title]="
                (('agenda-detail-meta-' + getOptionDict(key) | fromDictionary: false) || (key === 'from' ? 'Datum' : key)) +
                ': ' +
                getValue(key, val)
              "
            >
              <span class="sr-only">{{ key }}:</span>
              <span>{{ getValue(key, val) || val }}</span>

              <!--  add to if  -->
              <fstr-icon anchor="line-icon-x" class="icon-xs mt-1"></fstr-icon>
            </button>
          </li>

          <!--}-->
        }
      }

      @if (activeFilterCount() > 1) {
        <li>
          <a class="button button-link button--light active-filter-option gap-1" [routerLink]="['/agenda']">
            <span>{{ 'agenda-filters-reset' | fromDictionary }}</span>

            <!--  add to if  -->
            <fstr-icon anchor="line-icon-x" class="icon-xs mt-1"></fstr-icon>
          </a>
        </li>
      }
    </ul>
  </div>
}
